export const environment = {
  production: false,
  // baseUrl: 'https://oryxbit.local',
  baseUrl: 'https://oryxbit.com',
  //frontEndUrl: 'https://oryxbit.local', // Points to your front-end
  frontEndUrl: 'https://oryxbit.com', // Points to your front-end
};
